var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2087.33 113 22 12.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(2087.33 113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M44.926,45.841H27.734a2.288,2.288,0,0,0-2.4,2.146v8.582a2.288,2.288,0,0,0,2.4,2.145H44.926a2.288,2.288,0,0,0,2.4-2.145V47.987A2.289,2.289,0,0,0,44.926,45.841Zm1.695,10.728a1.583,1.583,0,0,1-1.695,1.436H27.734a1.584,1.584,0,0,1-1.695-1.436V47.987a1.584,1.584,0,0,1,1.695-1.437H44.926a1.584,1.584,0,0,1,1.695,1.437v8.582Z",
    transform: "translate(-25.33 -45.841)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    className: "cls-1",
    width: 8.143,
    height: 0.709,
    transform: "translate(2.561 3.906)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "cls-1",
    width: 8.143,
    height: 0.709,
    transform: "translate(2.561 6.141)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "cls-1",
    width: 4.648,
    height: 0.709,
    transform: "translate(14.22 8.318)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.6f0bf70709ac8e0eeb2d6ca4adc0749f.svg";
export { ForwardRef as ReactComponent };